import { pvPsvActions } from '@redux/slices/pv-psv';
import { getAppDispatch } from '@utilities/dispatch.util';
import { store } from 'redux/store';

const psvsJsonManipulation = ({ data }) => {
  const { items = [] } = data;

  const { pvPsv: oldPvPsv = [] } = store.getState()?.pvPsv || {};

  let newList = [];

  let newNumber = oldPvPsv?.filter((x) => x?.isNew) || [];

  newList = [...items, ...newNumber];

  const pvPsv = newList || [];
  const pvPsvMap = pvPsv?.reduce((acc, { pvId, psvId }) => {
    if (!acc[pvId]) acc[pvId] = { pv: [], psv: [] }; // for uniqueness
    if (!acc[psvId]) acc[psvId] = { pv: [], psv: [] }; // for uniqueness
    acc[pvId].psv.push(psvId);
    acc[psvId].pv.push(pvId);
    return acc;
  }, {});

  return {
    pvPsv,
    pvPsvMap
  };
};

const psvsDispatcher = ({ data }) => {
  const dispatch = getAppDispatch();

  dispatch?.(pvPsvActions.setPVPSV(data));
};

const deleteNewPSVRelation = ({ pvId, psvId }) => {
  console.log({ pvId, psvId });
  const dispatch = getAppDispatch();

  const { pvPsv: oldPvPsv = [] } = store.getState()?.pvPsv || {};

  let oldPvPsvCOpy = [...oldPvPsv];

  let pvPsv = oldPvPsvCOpy?.filter((x) => !(x?.pvId === pvId && x.psvId === psvId && x.isNew));

  const pvPsvMap = pvPsv?.reduce((acc, { pvId, psvId }) => {
    if (!acc[pvId]) acc[pvId] = { pv: [], psv: [] }; // for uniqueness
    if (!acc[psvId]) acc[psvId] = { pv: [], psv: [] }; // for uniqueness
    acc[pvId].psv.push(psvId);
    acc[psvId].pv.push(pvId);
    return acc;
  }, {});

  dispatch?.(
    pvPsvActions.setPVPSV({
      pvPsv,
      pvPsvMap
    })
  );
};

export { psvsJsonManipulation, psvsDispatcher, deleteNewPSVRelation };
